import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "dsa",
  "aria-labelledby": "dsa-title"
}
const _hoisted_2 = { class: "dsa-head" }
const _hoisted_3 = {
  key: 0,
  class: "dsa-empty"
}
const _hoisted_4 = {
  key: 0,
  class: "dsa-note dsa-note--warn",
  role: "note"
}
const _hoisted_5 = {
  key: 1,
  class: "dsa-note dsa-note--warn",
  role: "note"
}
const _hoisted_6 = {
  key: 2,
  class: "dsa-token-new",
  role: "status"
}
const _hoisted_7 = { class: "dsa-token-row" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "dsa-facts" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "dsa-mono" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "dsa-mono ms-2" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "dsa-actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_21 = {
  key: 1,
  class: "ph ph-key me-1",
  "aria-hidden": "true"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 3,
  class: "dsa-calls"
}
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table table-sm align-middle mb-0" }
const _hoisted_26 = { class: "text-nowrap" }
const _hoisted_27 = { class: "dsa-mono" }
const _hoisted_28 = { class: "text-muted ms-1 small" }
const _hoisted_29 = { class: "small" }
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", null, [
        _createElementVNode("h3", {
          id: "dsa-title",
          class: "dsa-title"
        }, [
          _createElementVNode("i", {
            class: "ph ph-plugs-connected",
            "aria-hidden": "true"
          }),
          _createTextVNode(" Accès API — changement de statut ")
        ]),
        _createElementVNode("p", { class: "dsa-sub" }, " Le système du livreur s'identifie avec son driver-code (ancien id, comme chez Kargo) pour modifier le statut de ses colis. Le token ci-dessous sert au format JSON natif. ")
      ], -1)),
      _createVNode(_component_router_link, {
        to: "/driver-status-api-docs",
        class: "btn btn-sm btn-outline-primary"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("i", {
            class: "ph ph-book-open me-1",
            "aria-hidden": "true"
          }, null, -1),
          _createTextVNode(" Documentation API – Changement de statut ", -1)
        ])),
        _: 1,
        __: [4]
      })
    ]),
    (_ctx.loading && !_ctx.access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[6] || (_cache[6] = [
          _createElementVNode("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status"
          }, null, -1),
          _createTextVNode(" Chargement… ", -1)
        ])))
      : (_ctx.access)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.access.enabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", {
                    class: "ph ph-warning",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" L'option « Autoriser le changement de statut des colis via API » est désactivée : les appels de ce livreur sont refusés (API_ACCESS_DISABLED) même avec un driver-code valide. ", -1)
                ])))
              : (!_ctx.access.active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[8] || (_cache[8] = [
                    _createElementVNode("i", {
                      class: "ph ph-warning",
                      "aria-hidden": "true"
                    }, null, -1),
                    _createTextVNode(" Le compte du livreur est désactivé : les appels sont refusés (ACCOUNT_INACTIVE). ", -1)
                  ])))
                : _createCommentVNode("", true),
            (_ctx.plainToken)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Nouveau driver-code — copiez-le maintenant, il ne sera plus affiché.", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      class: "form-control dsa-mono",
                      value: _ctx.plainToken,
                      readonly: "",
                      "aria-label": "driver-code API",
                      onFocus: _cache[0] || (_cache[0] = ($event: any) => (($event.target as HTMLInputElement).select()))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.plainToken)))
                    }, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", {
                        class: "ph ph-copy me-1",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.copied ? "Copié" : "Copier"), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("dl", _hoisted_9, [
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("dt", null, "driver-code", -1)),
                (_ctx.access.driver_code)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.access.driver_code), 1),
                      _cache[11] || (_cache[11] = _createTextVNode()),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted" }, "(à envoyer dans le paramètre driver-code)", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("dd", _hoisted_12, _cache[13] || (_cache[13] = [
                      _createElementVNode("span", { class: "badge text-outline-secondary rounded-pill" }, "Aucun ancien id", -1)
                    ])))
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("dt", null, "Token JSON", -1)),
                (_ctx.access.has_token)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_13, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "badge text-outline-success rounded-pill" }, "Actif", -1)),
                      _createElementVNode("span", _hoisted_14, "sdl_••••" + _toDisplayString(_ctx.access.token_hint), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("dd", _hoisted_15, _cache[16] || (_cache[16] = [
                      _createElementVNode("span", { class: "badge text-outline-secondary rounded-pill" }, "Aucun code", -1)
                    ])))
              ]),
              (_ctx.access.has_token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[18] || (_cache[18] = _createElementVNode("dt", null, "Créé le", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.access.token_created_at)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.access.has_token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[19] || (_cache[19] = _createElementVNode("dt", null, "Dernière utilisation", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_ctx.access.last_used_at ? _ctx.formatDate(_ctx.access.last_used_at) : "Jamais"), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                disabled: _ctx.busy,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
              }, [
                (_ctx.busy)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                  : (_openBlock(), _createElementBlock("i", _hoisted_21)),
                _createTextVNode(" " + _toDisplayString(_ctx.access.has_token ? "Régénérer le driver-code" : "Générer un driver-code"), 1)
              ], 8, _hoisted_19),
              (_ctx.access.has_token)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-outline-danger",
                    disabled: _ctx.busy,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revoke && _ctx.revoke(...args)))
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("i", {
                      class: "ph ph-prohibit me-1",
                      "aria-hidden": "true"
                    }, null, -1),
                    _createTextVNode(" Révoquer ", -1)
                  ]), 8, _hoisted_22))
                : _createCommentVNode("", true)
            ]),
            (_ctx.access.recent_calls.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "dsa-calls-title" }, "Derniers appels", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { scope: "col" }, "Date"),
                          _createElementVNode("th", { scope: "col" }, "Colis"),
                          _createElementVNode("th", { scope: "col" }, "Résultat"),
                          _createElementVNode("th", { scope: "col" }, "Changement")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.access.recent_calls, (call) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: call.id
                          }, [
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatDate(call.created_at)), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(call.parcel_code || "—"), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge rounded-pill", call.success ? 'text-outline-success' : 'text-outline-danger'])
                              }, _toDisplayString(call.success ? "OK" : call.error_code), 3),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(call.http_status), 1)
                            ]),
                            _createElementVNode("td", _hoisted_29, [
                              (call.success)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(call.old_status) + " → " + _toDisplayString(call.new_status), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}